<template>
        <div class="main user-profile">
        <div class="content">
            <h3 class="title mb-0 d-none d-md-block">
                Hejsan!
            </h3>

            <p class="mb-4">
                Välkommen till "Mina sidor". Här kan du uppdatera dina uppgifter.<br>
                Anger du födelsenummer och ålder på dina barn, så har du chansen att bli överraskad<br> på födelsedagen och även få personligt anpassade erbjudanden!
            </p>

            <div class="row">
                <div class="col-12 col-md-6 text-md-right">
                    <div class="register-base profile-base fcard float-md-right mx-auto mb-5">
                        <img src="/assets/frontend/register_base.svg" alt="">

                        <div class="user-info">
                            <span class="user-title" v-if="user.first_name || user.last_name">{{ $t('name') }}</span>
                            <span class="user-value" v-if="user.first_name || user.last_name">{{user.first_name}} <span v-if="user.last_name"></span>{{user.last_name}}</span>

                            <span class="user-title">{{ $t('email') }}</span>
                            <span class="user-value">{{user.email}}</span>
                        </div>

                    </div>
                </div>
                <div :class="{'col-12 col-md-6': !$isMobile, 'w-full': $isMobile}">
                    <edit-member-component :user="user" v-if="userLoaded" @updated="profileUpdated"></edit-member-component>
                </div>
            </div>
            <span class="info" v-html="$t('keep_updated')"></span>

        </div>
    </div>
</template>

<script>
    export default {
        inject: ['$isMobile'],
        data(){
            return{
                userLoaded: false,
                user: {contact: {}},
            }
        },
        mounted() {
            this.getUser();
            window.scrollTo(0, 0);
        },
        metaInfo() {
            return {
                title: 'Min profil - Familjekortet',
            };
        },
        methods: {
            getUser(){
                axios.get('/api/auth/user').then(response => {
                    this.user = response.data.data;
                    this.userLoaded = true;
                });
            },

            profileUpdated () {
                this.$moshaToast('Din profil har blivit uppdaterad!', {
                    type: 'success',
                    timeout: 2000,
                });

                this.getUser();
            },

            goToEdit(){
                this.$router.push({name:'edit-profile'});
            }
        }
    }
</script>
